'use strict';

import angular from 'angular';

export function DefaultFilter() {
  'ngInject';

  let filter = (input, defaultValue) => (_.isUndefined(input) || input === null || input === '') ? defaultValue : input;

  return filter;
}


// WEBPACK FOOTER //
// ./client/filter/default.filter.js